import {NgModule} from '@angular/core';
import {RouterModule, Routes, UrlSegment} from '@angular/router';
import {SUPPORTED_LANGUAGES} from '@core/constants/languages';
import {legalDocuments} from '@core/constants/legal-documents';
import {RouteNames} from '@core/constants/routes';
import {LanguagePrefixGuard} from '@core/guards/language-prefix.guard';

export const routes: Routes = [
  {
    matcher: url =>
      (SUPPORTED_LANGUAGES as string[]).includes(url[0]?.path)
        ? {consumed: [url[0]], posParams: {language: new UrlSegment(url[0].path, {})}}
        : null,
    children: [
      // some of routes are created dynamically based on the links from the API - see app.initializer.ts for more details
      {
        path: RouteNames.watch,
        loadChildren: () =>
          import('@views/view-video/view-video.module').then(m => m.ViewVideoModule),
      },
      {
        path: RouteNames.offer,
        title: 'views.offer',
        loadChildren: () =>
          import('@views/view-offer/view-offer.module').then(m => m.ViewOfferModule),
      },
      {
        path: RouteNames.faq,
        title: 'views.faq',
        loadChildren: () =>
          import('@views/view-faq/view-faq.module').then(m => m.ViewFaqModule),
      },
      {
        path: RouteNames.search,
        title: 'views.search',
        loadChildren: () =>
          import('@views/view-search/view-search.module').then(m => m.ViewSearchModule),
      },
      {
        path: RouteNames.formatProfile,
        loadChildren: () =>
          import('@views/view-format/view-format.module').then(m => m.ViewFormatModule),
      },
      {
        path: RouteNames.playlistProfile,
        loadChildren: () =>
          import('@views/view-playlist/view-playlist.module').then(
            m => m.ViewPlaylistModule,
          ),
      },
      {
        path: RouteNames.club,
        loadChildren: () =>
          import('@views/view-club/view-club.module').then(m => m.ViewClubModule),
      },
      {
        path: RouteNames.privacyPolicy,
        redirectTo: RouteNames.dataProtectionPolicy,
      },
      {
        matcher: url => {
          if (
            url.length === 1 &&
            legalDocuments.map(page => page.slug as string).includes(url[0].path)
          ) {
            return {
              consumed: [],
            };
          }

          return null;
        },
        loadChildren: () =>
          import('@views/view-legal-document/view-legal-document.module').then(
            m => m.ViewLegalDocumentModule,
          ),
      },
      {
        path: RouteNames.table,
        title: 'views.table',
        loadChildren: () =>
          import('@views/view-table/view-table.module').then(m => m.ViewTableModule),
      },
      {
        path: RouteNames.clubs,
        title: 'views.clubs',
        loadChildren: () =>
          import('@views/view-clubs/view-clubs.module').then(m => m.ViewClubsModule),
      },
      {
        path: 'error',
        loadChildren: () =>
          import('@views/view-errors/view-errors.module').then(m => m.ViewErrorsModule),
      },
      {
        path: '**',
        loadChildren: () =>
          import('@views/view-errors/view-errors.module').then(m => m.ViewErrorsModule),
      },
    ],
  },
  {
    // This is a dummy route, used to prepend language prefix to routes that don't contain it.
    path: '**',
    children: [],
    canActivate: [LanguagePrefixGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
